import React, { useEffect, useMemo, useState } from 'react'
import Stars from './Stars'
import { connect, useDispatch } from 'react-redux'
import axios from 'axios'
import { Row, Col, Button } from 'reactstrap'
import CustomSelect from '../../../common/CustomReactSelectComponent'
import { closeModal } from '../../GlobalModal/redux/GlobalModalActions'
import { clearErrorOnHandleChange } from '../../../actions/errorsActions'
import { getContactsDivisions } from '../../../modules/Contacts/redux/ContactActions'

import { notificationSuccess } from '../../../utils/customToastify'

import {
  ACCOUNT_SOURCE,
  EFFORT_LEVEL,
  NATIONALITY,
  PROSPECT_GRADE,
  PROSPECT_SOURCE,
} from '../../../constants/supportTypes'
import { LEAD_STATUS, PROSPECT_STATUS, VERIFIED_LEAD_STATUS } from '../../../constants/statuses'
import { LOGISTICS, TRUCK_SALES } from '../../../constants/divisions'
import { TRUCK_SALES_DEALER } from '../../../constants/contactCategory'

const ConvertingComponents = ({
  divisions = {},
  closeModal,
  errors = {},
  contactId,
  loadData,
  divisionId,
  contactCategory,
  userId,
  clearErrorOnHandleChange,
  getContactsDivisions,
  contact,
  dashComplete,
  taskData,
}) => {
  const dispatch = useDispatch()
  const [data, setData] = useState({})

  const [submitting, setSubmitting] = useState(false)

  const [options, setOptions] = useState({
    ProspectGrade: [],
    ProspectSource: [],
    AccountSource: [],
    Nationality: [],
    EffortLevel: [],
  })

  useEffect(() => {
    loadTypes()
  }, [])

  useEffect(() => {
    setData((prev) => ({ ...prev, nationalityId: contact.nationalityId }))
  }, [contact])

  useEffect(() => {
    if (errors?.error) {
      setSubmitting(false)
    }
  }, [errors])

  const loadTypes = async () => {
    const response = await axios.get(
      `/support-types/supportTypesForSelects/?types=${PROSPECT_SOURCE}&types=${PROSPECT_GRADE}&types=${NATIONALITY}&types=${EFFORT_LEVEL}&types=${ACCOUNT_SOURCE}`
    )
    let options = {}
    response.data.map((i) => {
      return (options[i.name.replace(/\s/g, '')] = i.data)
    })
    setOptions(options)
  }

  const convertContact = async () => {
    setSubmitting(true)
    const response = await axios.post('/contacts/convertContact', {
      statusId: divisions.statusId,
      divisionId: divisionId,
      contactId: contactId,
      contactCategory,
      userId: userId,
      creationDate: new Date(),
      ...data,
    })
    if (response.status === 200) {
      if (dashComplete) {
        const {
          data: { id: selectedTaskId },
          dashboardTasks,
          query,
        } = taskData
        const newTasks = dashboardTasks.map((mappedTask) => {
          if (mappedTask.id === selectedTaskId) {
            if (mappedTask.contactStatus === 'Lead') {
              mappedTask.contactStatus = 'Prospect'
            } else if (mappedTask.contactStatus === 'Prospect') {
              mappedTask.contactStatus = 'Account'
            }
          }
          return mappedTask
        })
        dispatch({
          type: 'GET_TASKS_FOR_DASHBOARD',
          payload: {
            query: { ...query, isRefresh: true },
            data: newTasks,
          },
        })
      }
      closeModal('converting_contacts')
      notificationSuccess('⭐ Conversion successful ⭐')
    }
    await loadData(contactId)
    await getContactsDivisions(contactId)
  }

  const handleChange = (e, name) => {
    setData({ ...data, [name]: e.id })
    clearErrorOnHandleChange(name)
  }

  // Isto pravilo kao u ContactHeader-u: Truck Sales kupci postaju Account automatski
  // po zatvaranju kvote, pa im je rucna konverzija zabranjena. Dealeri nemaju kvote
  // i konvertuju se iskljucivo rucno.
  const preventConversionProspectToAccount = useMemo(() => {
    if (
      divisions.statusId === PROSPECT_STATUS &&
      divisionId === TRUCK_SALES &&
      contactCategory !== TRUCK_SALES_DEALER
    ) {
      return true
    }
    return false
  }, [divisions, divisionId, contactCategory])

  const labels = (() => {
    const isLogistics = divisionId === LOGISTICS
    const statusId = divisions.statusId

    let from = 'Lead'
    let to = 'Prospect'

    if (statusId === PROSPECT_STATUS) {
      from = 'Prospect'
      to = 'Account'
    }

    if (isLogistics) {
      if (statusId === LEAD_STATUS) {
        from = 'Unverified Lead'
        to = 'Verified Lead'
      }

      if (statusId === VERIFIED_LEAD_STATUS) {
        from = 'Verified Lead'
        to = 'Prospect'
      }
    }

    return { from, to }
  })()

  return (
    <>
      <div className='contact_convert'>
        <div style={{ marginLeft: '4%' }}>
          Are you sure you wish to <span className='font-weight-bold'>claim &amp; convert</span> this {labels.from} to
          an <span className='font-weight-bold'>{labels.to}</span>
        </div>
        {divisions.statusId === LEAD_STATUS && (
          <p
            style={{
              color: '#D9534F',
              fontWeight: '600px',
              marginTop: '9px',
              marginLeft: '4%',
            }}
          >
            <i className='fa fa-hand-o-right' /> Select the Effort Level &amp; Grade to proceed:
          </p>
        )}
        <Row>
          {divisions.statusId === LEAD_STATUS && (
            <Col className='effort_level_box' xs={12} md={6} lg={6}>
              <div className='font-weight-bold effort_level_box-title'>Effort Level</div>
              <div className='effort_level_box-stars'>
                <Stars effortLevelIds={options.EffortLevel} handleChange={handleChange} contact={contact} />
                {(errors.effortLevel || errors.error?.effortLevel) && (
                  <small className='text-danger d-block'>{errors.effortLevel}</small>
                )}
              </div>
            </Col>
          )}
          {divisions.statusId === LEAD_STATUS && (
            <Col xs={12} md={6} lg={6} className='customBoxSmaller'>
              <CustomSelect
                isMulti={false}
                label='Grade'
                placeholder='Grade'
                onChange={(e) => handleChange(e, 'grade')}
                defaultValue={data.grade || 0}
                options={[{ name: 'Please Select' }, ...options.ProspectGrade]}
                invalid={!!errors.error?.grade}
                errorMess={errors.error?.grade}
              />
            </Col>
          )}
          {divisions.statusId === LEAD_STATUS && <Col xs={12} md={6} lg={6} />}

          <Col xs={12} md={6} lg={6} className='mt-3 customBoxSmaller'>
            <div className='custom_select_reverse'>
              {divisions.statusId === PROSPECT_STATUS && (
                <CustomSelect
                  isMulti={false}
                  label={'Account Source'}
                  placeholder={'Account Source'}
                  onChange={(e) => handleChange(e, 'accountSource')}
                  defaultValue={data.accountSource || 0}
                  options={[{ name: 'Please Select' }, ...options.AccountSource]}
                  invalid={!!errors.error?.accountSource}
                  errorMess={errors.error?.accountSource}
                />
              )}
              {divisions.statusId !== PROSPECT_STATUS && divisions.statusId !== VERIFIED_LEAD_STATUS && (
                <CustomSelect
                  isMulti={false}
                  label='Prospect Source'
                  placeholder='Prospect Source'
                  onChange={(e) => handleChange(e, 'prospectSource')}
                  defaultValue={data.prospectSource || 0}
                  options={[{ name: 'Please Select' }, ...options.ProspectSource]}
                  invalid={!!errors.error?.prospectSource}
                  errorMess={errors.error?.prospectSource}
                />
              )}
            </div>
          </Col>
          {divisions.statusId === PROSPECT_STATUS && (
            <Col xs={12} md={6} lg={6} className='mt-3'>
              <CustomSelect
                isMulti={false}
                label='Preferred Language'
                placeholder='Select...'
                onChange={(e) => handleChange(e, 'nationalityId')}
                defaultValue={data.nationalityId || 0}
                options={[{ name: 'Please Select' }, ...options.Nationality]}
                invalid={!!errors.error?.nationalityId}
                errorMess={errors.error?.nationalityId}
              />
            </Col>
          )}
        </Row>
        <Row className='justify-self-bottom text-right convertBox'>
          <Col className=''>
            <Button
              className={'btn btn-gold'}
              onClick={() => convertContact()}
              disabled={submitting || preventConversionProspectToAccount}
            >
              Ok
            </Button>
            <Button className={'btn btn-gold ml-3'} onClick={() => closeModal('converting_contacts')}>
              Cancel
            </Button>
          </Col>
        </Row>
      </div>
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    errors: state.errors,
    divisionId: state.auth.user.division_id,
    userId: state.auth.user.userId,
    taskData: state.Task,
  }
}

export default connect(mapStateToProps, {
  closeModal,
  clearErrorOnHandleChange,
  getContactsDivisions,
})(ConvertingComponents)
